import { getEnvironmentVariable } from '../../core/helpers'

const MAX_NUMBER_OF_MENUS_IN_TEMPLATE_VALIDATION_STEP =
  Number(
    getEnvironmentVariable(
      'REACT_APP_MAX_NUMBER_OF_MENUS_IN_TEMPLATE_VALIDATION_STEP',
    ),
  ) || 100

export default MAX_NUMBER_OF_MENUS_IN_TEMPLATE_VALIDATION_STEP
